import { Container, Grid, Typography, makeStyles } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import InputBuscadorPaginadoWithFormik from '../../../components/InputBuscadorPaginadoWithFormik';
import AutocompleteWithFormik from '../../../components/inputs/AutocompleteWithFormik';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import axios from '../../../utils/axios';
import Filter from '../../../utils/filter';
import createParams from '../../../utils/tables-params';
import personaConfig from './PersonaConfig';

const useStyles = makeStyles(theme => ({
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  }
}));

const EntregaForm = props => {
  const { gridProps, enqueueSnackbar } = props;
  const formik = useFormikContext();
  const classes = useStyles();

  const configuraciones = personaConfig({
    classes: {}
  });
  const dataset = 'entrega';

  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const settings = datosSettings;
    const params = createParams({ ...props.personasForm.list, settings });
    params.sorting.sortingConditions = [{ path: 'id', sortingType: 'desc' }];
    if (params.filter) {
      params.filter.and(Filter.path('activado').eq(1));
      params.filter = JSON.stringify(params.filter);
    } else {
      params.filter = JSON.stringify(Filter.path('activado').eq(1));
    }
    axios
      .get(datosConfig.servicio, {
        data: {},
        params
      })
      .then(resp => {
        return props.personasForm.list.dataLoaded(
          resp.data.data.map(item => ({
            ...item,
            info: `${item.nombre} ${item.apellido}`
          })),
          {
            currentPage: resp.data.meta.currentPage - 1,
            pageSize: resp.data.meta.pageSize,
            itemsCount: resp.data.meta.total
          }
        );
      })
      .catch(() => {
        enqueueSnackbar('Error al obtener los datos', 'error');
      });
  };
  return (
    <Container maxWidth="sm" className={classes.innerContainer}>
      <div style={{ paddingBottom: 40 }}>
        <Grid container item>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Formulario para carga de datos de la entrega
          </Typography>
        </Grid>
        <Grid container {...gridProps}>
          <Grid item xs={12} md={12}>
            <ListDataProvider
              listStore={props.personasForm.list}
              render={listProps => (
                <InputBuscadorPaginadoWithFormik
                  required
                  label="Seleccione quién entregará las mercaderías"
                  name="persona"
                  labelKey="info"
                  valueKey="id"
                  placeholder="Seleccione..."
                  list={listProps}
                  datosConfig={datosConfig}
                  datosSettings={datosSettings}
                  onReloadTable={onReloadTable}
                  onSelected={(_, item) => {
                    formik.setFieldValue('persona', item);
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <AutocompleteWithFormik
              required
              label="¿Qué hacer en caso de no efectuarse la entrega?"
              name="instruccion"
              options={[
                { texto: 'Devolver', id: 'Devolver' },
                { texto: 'Abandonar', id: 'Abandonar' }
              ]}
              labelKey="texto"
              valueKey="id"
              isObjectValue
            />
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default inject('personasForm')(observer(withSnackbar(EntregaForm)));
